import { createFileRoute } from "@tanstack/react-router";

import { RevenueDashboard } from "../tools/dashboards/RevenueDashboard";

function RevenueRoute() {
  return <RevenueDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/revenue")({
  component: RevenueRoute,
});
